import {UserLevel} from '@netx/core-user-next/constants';

export const CURRENT_CART_UPLOAD_MINIMUM_USER_LEVEL = UserLevel.CONSUMER;

export const CURRENT_CART_UPLOAD_FILE_FORMATS = [
	'text/csv',
	// Only csv atm
	// 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export const DOCUMENTATION_LINK = `https://support.netx.net/hc/en-us/articles/4408876338199-Selection-Uploader`;
